import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";

@Component({
  selector: "app-admin-add-tax",
  templateUrl: "./admin-add-tax.component.html",
  styleUrls: ["./admin-add-tax.component.css"],
})
export class AdminAddTaxComponent implements OnInit {
  addTaxForm: FormGroup;
  truckCategory: any = [];
  truckTypeList: any = [];
  taxArray: any = [];
  s9Array: any = [];
  customerArray: any = [];
  driverArray: any = [];
  exemptedArray: any = [];
  token: any;
  selectTaxValue: any;
  loading: boolean = false;
  add_tax: any;
  perPage: any = 100;
  startPage: any = 1;
  searchEmployeeName: any = -1;

  constructor(
    private matdialogref: MatDialogRef<AdminAddTaxComponent>,
    private formBuilder: FormBuilder,
    private services: AdminService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.taxFormGroup();
    this.GetCategory();
  }
  close() {
    this.matdialogref.close();
  }

  public GetCategory() {
    this.services
      .GetCategory(
        this.token,
        this.searchEmployeeName,
        this.perPage,
        this.startPage
      )
      .subscribe(
        (response: any) => {
          if (response.status === 200) {
            this.truckCategory = response.body.data;
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  gettruckCatg(item: any) {
    this.selectTaxValue = item.value;
    this.services.GetTypeTruck(this.selectTaxValue, this.token).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.truckTypeList = response.body.data;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  getTaxtype(item: any) {
    this.add_tax = item.value;
  }
  taxFormGroup() {
    this.addTaxForm = this.formBuilder.group({
      tax_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(/[a-zA-Z0-9\s]*$/),
        ]),
      ],
      tax_description: ["", [Validators.required]],
    });
    if (this.data?.type !== "customerGST") {
      this.addTaxForm.addControl(
        "tax_deduction",
        this.formBuilder.control("", [
          Validators.required,
          Validators.pattern("^[.0-9]*$"),
        ])
      );
      this.addTaxForm.addControl(
        "tax_type",
        this.formBuilder.control("", Validators.required)
      );
    }
    if (this.data?.type === "customerGST") {
      this.addTaxForm.addControl(
        "hsn_code",
        this.formBuilder.control("", Validators.required)
      );
      this.addTaxForm.addControl(
        "rcm_deduction",
        this.formBuilder.control("")
      );
      this.addTaxForm.addControl(
        "fcm_deduction",
        this.formBuilder.control("")
      );
    }
  }

  addTax() {
    if (this.addTaxForm.valid) {
      let taxObj: any = {
        tax_name: this.addTaxForm.value.tax_name.toUpperCase(),
        // tax_type: this.add_tax.toLowerCase(),
        // tax_deduction: this.addTaxForm.value.tax_deduction,
        tax_description: this.addTaxForm.value.tax_description,
        tax_user_type: this.data.type,
      };
      if (this.data.type !== "customerGST") {
        taxObj.tax_deduction = this.addTaxForm.value.tax_deduction;
        taxObj.tax_type = this.add_tax.toLowerCase();
      }
      // Added extra fields if usertype is customerGST
      if (this.data.type === "customerGST") {
        taxObj.hsn_code = this.addTaxForm.value.hsn_code;
        taxObj.rcm_deduction = this.addTaxForm.value.rcm_deduction || 0;
        taxObj.fcm_deduction = this.addTaxForm.value.fcm_deduction || 0;
        taxObj.tax_type = "percent"
      }

      this.loading = true;
      this.services.taxAdd(taxObj, this.token).subscribe(
        (response: any) => {
          if (response.status == 201) {
            this.snackBar.open("Tax Added successfully", "Success", {
              duration: 5000,
            });
            this.loading = false;
            this.matdialogref.close(this.data);
            this.toRefreshGrpList();
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed" || error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
          this.loading = false;
        }
      );
    }
  }
  toRefreshGrpList() {
    let value = 1;
    let triptype = "tax";
    localStorage.setItem("tripType", triptype);
    this.services.sendLRRefreshData(value);
  }
}
